'use client';

import { logger } from '@libs/core';

import { useDecisions } from '../../hooks';
import type { Decisions } from '../../types';
import { useSyncExperiments } from './experiments.hook';

interface Props {
    experiments: Partial<Pick<Decisions, Extract<keyof Decisions, string>>>;
}
export function ExperimentTracker({ experiments }: Props) {
    useSyncExperiments();
    const all = useDecisions();

    Object.keys(experiments).forEach(key => {
        const value = all[key as keyof Decisions];
        logger.debug('[Optimizely] Sending impression for %s: %s', key, value);
    });

    return null;
}
